/* KARMA: kartya szin-pottyok - kattintasra a kartya kepe a valasztott szinre valt.
   Delegalt listener: tuleli a szuro (facets.js) AJAX ujra-renderelest. */
(function () {
  function swap(sw) {
    var card = sw.closest('.card-wrapper');
    if (!card) return;
    var src = sw.getAttribute('data-src');
    if (!src) {
      var tn = sw.querySelector('img');
      if (tn) src = tn.currentSrc || tn.src;
    }
    if (!src) return;
    // elsodleges + hover-kep is a valasztott szinre (konzisztens hover)
    card.querySelectorAll('.card__media .media img').forEach(function (img) {
      img.removeAttribute('srcset');
      img.src = src;
    });
    card.querySelectorAll('.karma-swatch.is-active').forEach(function (s) {
      s.classList.remove('is-active');
    });
    sw.classList.add('is-active');
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.karma-swatch');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    swap(sw);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var sw = e.target.closest && e.target.closest('.karma-swatch');
    if (!sw) return;
    e.preventDefault();
    swap(sw);
  });

  /* ---- 1|2 oszlopos nezetvalto (mobil) - default: 1 oszlop, valasztas megjegyezve ---- */
  function applyCols() {
    var cols = '1';
    try { cols = localStorage.getItem('karmaCols') || '1'; } catch (e) {}
    document.querySelectorAll('#ProductGridContainer .product-grid').forEach(function (g) {
      g.classList.toggle('karma-grid-1col', cols === '1');
    });
    document.querySelectorAll('[data-karma-viewtoggle] .karma-viewtoggle__btn').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-cols') === cols);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-karma-viewtoggle] .karma-viewtoggle__btn');
    if (!btn) return;
    try { localStorage.setItem('karmaCols', btn.getAttribute('data-cols')); } catch (e2) {}
    applyCols();
  });

  /* ---- kategoria-kartyak SPA-szurese (kesztyuink hub): a kartya a Kategoria facetet
     allitja (felulirva az elozot); ujrakattintasra torli; chip-torlessel szinkronban ---- */
  var FPARAM = 'filter.p.m.custom.alkalom';
  /* a JSON-terkep kulcsai az ALKALOM-ERTEKEK, a szerver `_aktualis` mezoje viszont
     KOLLEKCIO-HANDLE - ez a terkep koti ossze a kettot */
  var CIMKE_HANDLE = {
    'Klasszikus': 'klasszikus', 'Sport': 'sport', 'Art': 'art',
    'Autós / vezetés': 'autos', 'Innováció / tech': 'innovacio'
  };

  /* A kollekcio-fejlec (cim + leiras) kovesse az aktiv alkalom-szurest, SPA-szures
     utan is, ugyanabbol a JSON-terkepbol mint a direkt betoltes (main-collection-banner). */
  function fejlecFrissit(active) {
    var el = document.querySelector('[data-karma-alkalom-terkep]');
    if (!el) return;
    var map;
    try { map = JSON.parse(el.textContent); } catch (e) { return; }
    /* A cimke-alapu URL-en (/collections/ferfi-kesztyu/autos) nincs facet-parameter,
       ezert a szerver beirja a JSON-be, melyik tematikus kulcs aktiv (`_aktualis`);
       facet-szures nelkul ezt hasznaljuk kiindulasnak, nem a bazist. */
    var alapKulcs = '_alap';
    if (map._aktualis) {
      for (var k in map) {
        if (k.charAt(0) !== '_' && map[k] && map[k].cim && CIMKE_HANDLE[k] === map._aktualis) alapKulcs = k;
      }
    }
    var kulcs = (active.length === 1 && map[active[0]]) ? active[0] : alapKulcs;
    var adat = map[kulcs] || map._alap;
    if (!adat) return;
    var cim = document.querySelector('[data-karma-cim]');
    var leiras = document.querySelector('[data-karma-leiras]');
    if (cim) {
      var rejtett = cim.querySelector('.visually-hidden');
      cim.textContent = adat.cim;
      if (rejtett) cim.insertBefore(rejtett, cim.firstChild);
    }
    if (leiras) leiras.innerHTML = adat.leiras || '';
  }

  function syncTiles() {
    var params = new URLSearchParams(window.location.search);
    var active = params.getAll(FPARAM);
    document.querySelectorAll('.karma-tile[data-filter-value]').forEach(function (t) {
      t.classList.toggle('is-current', active.indexOf(t.getAttribute('data-filter-value')) > -1);
    });
    fejlecFrissit(active);
  }

  document.addEventListener('click', function (e) {
    var tile = e.target.closest && e.target.closest('.karma-tile[data-filter-value]');
    if (!tile) return;
    if (typeof FacetFiltersForm === 'undefined' || !FacetFiltersForm.renderPage) return; /* fallback: navigal a kollekciora */
    e.preventDefault();
    var val = tile.getAttribute('data-filter-value');
    var params = new URLSearchParams(window.location.search);
    var wasActive = params.getAll(FPARAM).indexOf(val) > -1;
    params.delete(FPARAM);
    params.delete('page');
    if (!wasActive) params.append(FPARAM, val); /* ujrakattintas = torles */
    FacetFiltersForm.renderPage(params.toString());
    setTimeout(syncTiles, 0);
    if (window.innerWidth < 750) {
      var band = document.querySelector('.facets-container');
      if (band && band.scrollIntoView) band.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* ---- addon (himzett zsak) kosarba adasa AJAX-szal, cart-drawer frissitessel ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-karma-addon-add]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-karma-addon-row]') || btn.closest('.karma-zsakupsell') || document;
    var nameInput = wrap.querySelector('[data-karma-himzes-nev]');
    var props = {};
    if (btn.hasAttribute('data-karma-require-name')) {
      if (!nameInput || !nameInput.value.trim()) {
        if (nameInput) { nameInput.style.borderColor = '#b3401e'; nameInput.focus(); }
        return; /* himzeshez kell a szoveg */
      }
    }
    if (nameInput && nameInput.value.trim()) props['Hímzés'] = nameInput.value.trim();
    var cart = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(btn.getAttribute('data-karma-addon-add'), 10), quantity: 1, properties: props }] };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.disabled = false;
        var ok = (btn.closest('.karma-personal__body') || document).querySelector('[data-karma-addon-ok]');
        if (ok) ok.hidden = false;
        if (cart && res.sections && cart.renderContents) { cart.renderContents(res); }
        else if (document.querySelector('.cart-items')) { window.location.reload(); }
      })
      .catch(function () { btn.disabled = false; window.location.href = '/cart'; });
  });

  applyCols();
  syncTiles();
  // a szuro-AJAX ujrarendereli a gridet es a savot -> ujra-alkalmazzuk
  var pgc = document.getElementById('ProductGridContainer');
  if (pgc && window.MutationObserver) {
    new MutationObserver(function () { applyCols(); syncTiles(); }).observe(pgc, { childList: true, subtree: true });
  }
})();
